import { MediaLibCategoryEnum } from "@editor/modules/media-lib";
import { cn } from "@lib/cn";
import { useMemo } from "react";
import { useMediaLibFilesCtx } from "../../files/media-lib-files.ctx";
import { MEDIA_LIB_PANEL_CATEGORIES } from "../constants";
import { useMediaLibPanelStoreShallow } from "../stores";

export const MediaLibPanelCategories = () => {
  const { view } = useMediaLibFilesCtx();
  const {
    category,
    setCategory,
    setSelectedFolderId,
    setFiles,
    setWillLoadFiles,
  } = useMediaLibPanelStoreShallow((s) => ({
    setWillLoadFiles: s.setWillLoadFiles,
    category: s.category,
    setCategory: s.setCategory,
    setSelectedFolderId: s.setSelectedFolderId,
    setFiles: s.setFiles,
  }));

  const categories = useMemo(() => {
    if (view === "dialog") {
      return MEDIA_LIB_PANEL_CATEGORIES.filter(
        (c) => c.key !== MediaLibCategoryEnum.Archive,
      );
    }
    return MEDIA_LIB_PANEL_CATEGORIES;
  }, [view]);

  return (
    <ol className="tw-relative tw-m-0 tw-flex tw-list-none tw-items-center tw-justify-start tw-space-x-1.5 tw-overflow-x-auto tw-no-scrollbar tw-p-6 -sm:tw-px-3 -sm:tw-py-3">
      {categories.map((opt) => (
        <li
          key={opt.key}
          onClick={() => {
            if (category === opt.key) return;
            setFiles({ files: [], extend: false });
            setSelectedFolderId(null);
            setWillLoadFiles(true);
            setCategory(opt.key);
          }}
          className={cn({
            "tw-flex tw-shrink-0 tw-cursor-pointer tw-snap-center tw-items-center tw-text-nowrap tw-break-keep tw-rounded-md tw-px-2 tw-py-1 tw-text-[11px] tw-font-semibold tw-text-blue-600": true,
            "tw-bg-blue-100 tw-text-blue-800": category === opt.key,
          })}
        >
          {opt.label}
        </li>
      ))}
    </ol>
  );
};
